<template>
    <div v-if="!dismissed" class="right-0 w-full pb-2 sm:pb-5">
        <div class="p-2 rounded-lg shadow-lg bg-primary-500 sm:p-3">
            <div class="flex flex-wrap items-center justify-between">
                <div class="flex items-center flex-1 w-0">
                    <span class="flex p-2 rounded-lg bg-primary-700">
                        <svg class="w-6 h-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                            />
                        </svg>
                    </span>
                    <p class="mx-3 font-medium text-white break-words">
                        {{ announcement.content }}
                    </p>
                </div>
                <div class="flex-shrink-0 order-3 w-full mt-2 sm:order-2 sm:mt-0 sm:w-auto">
                    <div class="rounded-md shadow-sm">
                        <button
                            type="button"
                            @click="markSeen"
                            class="flex items-center justify-center px-4 py-2 text-sm font-medium leading-5 transition duration-150 ease-in-out bg-white border border-transparent rounded-md text-primary-600 hover:text-primary-500 focus:outline-none focus:shadow-outline"
                        >
                            Mark as seen
                        </button>
                    </div>
                </div>
                <div class="flex-shrink-0 order-2 sm:order-3 sm:ml-2">
                    <button
                        @click="dismissed = true"
                        type="button"
                        class="flex p-2 -mr-1 transition duration-150 ease-in-out rounded-md hover:bg-primary-500 focus:outline-none focus:bg-primary-500"
                    >
                        <svg class="w-6 h-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'team-announcement-footer',
    props: {
        announcement: Object,
    },
    data() {
        return {
            dismissed: false,
        };
    },
    methods: {
        markSeen() {
            this.dismissed = true;
            this.$emit('seen', this.announcement.id);
        },
    },
};
</script>
